import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

export interface GetMarketShopLinkRequest {
  buildingId?: number
}

export interface GetMarketShopLinkResponse {
  link: string
  id: number
  name: string
}

export const getMarketShopLinkQueryKey = (data: GetMarketShopLinkRequest) => [
  'useGetMarketShopLink',
  data,
]

export const getMarketShopLink = async (data: GetMarketShopLinkRequest, signal?: AbortSignal) => {
  const response = await authAPI.get<GetMarketShopLinkResponse[]>('/market-shop/link', {
    params: data,
    signal,
  })
  return response.data
}

export const useGetMarketShopLink = (data: GetMarketShopLinkRequest) => {
  return useQuery({
    enabled: !!data.buildingId,
    queryFn: ({ signal }) => getMarketShopLink({ ...data }, signal),
    queryKey: getMarketShopLinkQueryKey(data),
  })
}
